import {Location} from '@angular/common';
import {ActivatedRoute, Router} from '@angular/router';
import {inject} from '@angular/core';
import {environment} from '../../../environments/environment.prod';
import {HttpHelper} from '../../helpers/core/http.helper';
import {TemplateHelper} from '../../helpers/core/template.helper';
import {Pagination} from '../../models/pagination/pagination';
import {SearchFilter} from '../../models/search-filter/search.filter';
import {ResponseModel} from '../../models/response/response.model';
import {RequestHelperUrl} from '../../helpers/routes/request.helper.url';

export abstract class BaseService {
    protected httpHelper: HttpHelper;
    protected requestUrlHelper: RequestHelperUrl;
    protected router: Router;
    protected templateHelper: TemplateHelper;
    protected location: Location;
    public pagination: Pagination;
    public searchFilter: SearchFilter;
    private methodVal: string;
    private contentTypeVal: string;
    private dataVal: any;
    private requestUrlVal: string;
    private activatedRoute: ActivatedRoute;

    protected constructor() {
        this.init();
    }

    private init() {
        this.httpHelper = inject(HttpHelper);
        this.requestUrlHelper = inject(RequestHelperUrl);
        this.router = inject(Router);
        this.templateHelper = inject(TemplateHelper);
        this.location = inject(Location);
        this.activatedRoute = inject(ActivatedRoute);
        this.contentType = 'form';
        this.requestUrl = null;
        this.pagination = {} as Pagination;
        this.setSearchFilter();
    }

    get data(): any {
        return this.dataVal;
    }

    set data(value: any) {
        this.dataVal = value;
    }

    get contentType(): string {
        return this.contentTypeVal;
    }

    set contentType(value: string) {
        this.contentTypeVal = value;
    }

    get method(): string {
        return this.methodVal;
    }

    set method(value: string) {
        this.methodVal = value;
    }

    get requestUrl(): string {
        return this.requestUrlVal;
    }

    set requestUrl(value: string) {
        this.requestUrlVal = value;
    }

    get ActivatedRoute(): ActivatedRoute {
        return this.activatedRoute;
    }

    public getHttpHelper() {
        return this.httpHelper;
    }

    public getRequestUrlHelper() {
        return this.requestUrlHelper;
    }

    public getRouter() {
        return this.router;
    }

    public getTemplateHelper() {
        return this.templateHelper;
    }

    public generateUrl(key) {
        return this.getRequestUrlHelper().getUrl(key);
    }

    public request(key, filter: boolean = false) {
        try {
            let http = null;
            this.getTemplateHelper().setLoading(true);
            let url = key ? this.generateUrl(key) : this.requestUrl;
            url = this.implementFilters(url, filter);
            return new Promise((resolve, reject) => {
                switch (this.method) {
                    case 'post':
                        http = this.getHttpHelper().httpPost(url, this.data, this.contentType);
                        break;
                    case 'put':
                        http = this.getHttpHelper().httpPut(url, this.data, this.contentType);
                        break;
                    case 'delete':
                        http = this.getHttpHelper().httpDelete(url, this.contentType);
                        break;
                    case 'file':
                        http = this.getHttpHelper().fileUpload(url, this.data);
                        break;
                    case 'get':
                    default:
                        http = this.getHttpHelper().httpGet(url, this.contentType);
                        break;
                }
                this.reset();
                http.subscribe(response => {
                    this.getTemplateHelper().setLoading(false);
                    if (response.status) {
                        if (response.message) {
                            this.getTemplateHelper().showToast(response.message, 'success');
                        }

                        resolve(new ResponseModel(response));
                    } else {
                        this.getTemplateHelper().showToast(response.message, 'danger');
                        resolve(new ResponseModel(response));
                    }
                });
            });
        } catch (e) {
            this.getTemplateHelper().setLoading(false);
            this.getTemplateHelper().showToast(e.message, 'danger');
        }
    }

    public ResetFilter() {
        this.templateHelper.UpdateUrlState(this.templateHelper.WindowLocation().pathname);
        this.setSearchFilter();
    }

    private setSearchFilter() {
        this.searchFilter = {search: '', show: environment.PAGINATION, status: '', filter_by: '', page: 1};
        if (window.location.search) {
            const params = new URLSearchParams(window.location.search);
            Object.keys(this.searchFilter).map(key => {
                this.searchFilter[key] = params.get(key);
            });
        }
    }

    private Filters() {
        return this.templateHelper.ObjectToQueryParams(this.searchFilter);
    }

    private implementFilters(url: string, filter) {
        if (filter) {
            const filterVal = '?' + this.Filters();
            url += filterVal;
            this.templateHelper.UpdateUrlState(this.templateHelper.WindowLocation().pathname + filterVal);
        } else if (window.location.search) {
            url += window.location.search;
        }
        return url;
    }

    private reset() {
        this.contentType = 'form';
        this.method = 'get';
    }
}
